'use strict';

// EXPORTS //

module.exports = 4294967295; // 2**32 - 1
